// extracted by mini-css-extract-plugin
export var modal = "_g2-0";